
const selectLanguage = store => {
  return store.getIn(["language", "locale"])
}

export { selectLanguage };
